export default __webpack_public_path__ + "static/media/greenHike.9658420b.jpg";